<template>
	<div>
		<el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="88px">
			<el-form-item label="故障原因" prop="name">
				<el-input v-model="formData.name" placeholder="请输入故障原因" clearable :style="{ width: '100%' }"></el-input>
			</el-form-item>
			<el-form-item>
				<div style="text-align: right">
					<span class="dialog-footer">
						<el-button @click="formCancel">取 消</el-button>
						<el-button type="primary" @click="formSubmit">确 定</el-button>
					</span>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { addService, editService } from '@s/base/ProblemReasonService';

export default {
	components: {},
	props: ['selectData_p', 'isRefreshList_p'],
	data() {
		return {
			editId: -1,
			formData: {
				name: ''
			},
			rules: {
				name: [
					{
						required: true,
						message: '请输入故障原因',
						trigger: 'blur'
					}
				]
			}
		};
	},
	computed: {},
	watch: {
		selectData_p: {
			async handler(newValue) {
				if (newValue.length > 0) {
					this.editId = newValue[0].id;
					this.formData = { ...newValue[0] };
				}
			},
			deep: true,
			immediate: true
		}
	},
	mounted() {},
	methods: {
		formSubmit() {
			this.$refs.elForm.validate(async valid => {
				if (valid) {
					if (this.editId === -1) {
						await addService(this.formData);
						this.$emit('update:isRefreshList_p', true);
					} else {
						const dataJson = {
							id: this.editId,
							...this.formData
						};
						await editService(dataJson);
						this.$emit('update:isRefreshList_p', true);
					}
					this.formCancel();
				} else {
					this.$emit('update:isRefreshList_p', false);
				}
			});
		},
		formCancel() {
			this.$emit('update:isShowAEDialog_p', false);
		}
	}
};
</script>
<style></style>
